export const VerificationProcess = `verificationProcess/`;

export const SearchProcesses = VerificationProcess + 'Search';
export const SearchProcessTypes = VerificationProcess + 'SearchTypes';

export const GetVerificationProcessTypes = VerificationProcess + 'Types';
export const VerificationProcessType = VerificationProcess + 'Type';
export const EmailVerificationProcess = VerificationProcess + 'EmailVerificationProcess';
export const SortTypesOrder = VerificationProcess + 'SortOrder';
export const GetScorecardVerificationProcesses = VerificationProcess + 'Scorecard';
export const GetScorecardVerificationProcessReminders = VerificationProcess + 'Reminders';
export const CreateVerificationProcessReminder = VerificationProcess + 'Reminder';

